import { Link } from '@/ui-components/atoms/Link/Link';
import { DownloadIcon } from '@/assets/icons/DownloadIcon';
import { ChannelGuideData } from '@/services/contentful/contentTypes/ChannelGuide';

import styles from './channelGuide.module.scss';

const { downloadLinkMobile, downloadLinkDesktop, linkColor, downloadTextWrapper } = styles;

const downloadLinkStyles = {
    mobile: downloadLinkMobile,
    desktop: downloadLinkDesktop,
};

interface DownloadLinkProps {
    lineupLink: ChannelGuideData['fields']['channelLineup'];
    type: keyof typeof downloadLinkStyles;
}

export default function DownloadLink({ lineupLink, type }: DownloadLinkProps) {
    if (!lineupLink || !lineupLink.fields.href) {
        return null;
    }

    return (
        <div className={downloadLinkStyles[type]}>
            <Link href={lineupLink.fields.href} target="_blank" className={linkColor}>
                <div className={downloadTextWrapper}>
                    <DownloadIcon />
                    {lineupLink.fields.link_text || 'Download PDF Guide'}
                </div>
            </Link>
        </div>
    );
}
